import { AdminDashboardView } from './js/admin-dashboard';
import { DiagnosticsWatcher } from '@ui/DiagnosticsWatcher';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { MaintenanceView } from './js/gateway/maintenance';
import React from 'react';
import { SalesforceIntegration } from './js/gateway/integrations/Salesforce';
import { SharedDataDictionaryView } from '@dictionary/SharedDataDictionaryView';
import { AuthorizedView, AuthTokenRedirect, ConfirmLinkRouter, ExtensionAuthClose, UnauthorizedView } from './js/gateway';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Else, If, Then } from 'react-if';
import { useAuthToken, useMaintenanceMode } from '@hooks';
export const AppRoot = () => {
    const { isAdmin, isLoggedIn } = useAuthToken();
    const inMaintenanceMode = useMaintenanceMode();
    return (React.createElement(React.Fragment, null,
        React.createElement(ExtensionAuthClose, null),
        React.createElement(BrowserRouter, null,
            React.createElement(DiagnosticsWatcher, null),
            React.createElement(If, { condition: inMaintenanceMode },
                React.createElement(Then, null,
                    React.createElement(MaintenanceView, null)),
                React.createElement(Else, null,
                    React.createElement(Routes, null,
                        React.createElement(Route, { element: React.createElement(ConfirmLinkRouter, null), path: FULL_ROUTES.CONFIRM_LINK }),
                        React.createElement(Route, { element: React.createElement(AuthTokenRedirect, null), path: FULL_ROUTES.TOKEN }),
                        React.createElement(Route, { element: React.createElement(SalesforceIntegration, null), path: FULL_ROUTES.INTEGRATIONS_SALESFORCE }),
                        React.createElement(Route, { element: React.createElement(SharedDataDictionaryView, null), path: FULL_ROUTES.SHARED_VIEW }),
                        isAdmin && React.createElement(Route, { element: React.createElement(AdminDashboardView, null), path: FULL_ROUTES.ADMIN }),
                        React.createElement(Route, { element: isLoggedIn ? React.createElement(AuthorizedView, null) : React.createElement(UnauthorizedView, null), path: '*' })))))));
};
